import React from 'react';
import styled from 'styled-components';

export const Wrap = styled.div`
  margin: 30px 0;
`;

export const Title = styled.h3``;

export const Description = styled.p``;
